module.exports = __webpack_public_path__ + "static/media/animal-horse6.2b865d63.aac";